import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { ErrorMessage } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ErrorMessage";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { ContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import resetPasswordWithEmail from "@faire/web-api--source/api/user/reset-password/post";
import resetPassword from "@faire/web-api--source/api/user/reset-password/userToken/post";
import { ILoginDataRequest } from "@faire/web-api--source/indigofair/data/ILoginDataRequest";
import { ISendResetPasswordRequest } from "@faire/web-api--source/indigofair/data/ISendResetPasswordRequest";
import React, { useState } from "react";
export var ResetPasswordView = function(param) {
    var userToken = param.userToken, emailAddress = param.emailAddress;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(true), 2), showResend = _useState[0], setShowResend = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), error = _useState1[0], setError = _useState1[1];
    var onResend = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!userToken) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetPassword(userToken, ISendResetPasswordRequest.build({
                                resend: true
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!emailAddress) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            resetPasswordWithEmail(ILoginDataRequest.build({
                                email_address: emailAddress,
                                resend: true
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setError(new LoginError(strictLocalize({
                            id: "G4ClwW",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Email address not available. Please contact support."
                                }
                            ]
                        })));
                        _state.label = 5;
                    case 5:
                        setShowResend(false);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setError(convertErrorToLoginError(e, strictLocalize));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                "data-test-id": "check-email-prompt-header",
                children: showResend ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "uuNN1y",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Check your email"
                        }
                    ]
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "jlBYSP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sent!"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: showResend ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "xVPevm",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We just sent you instructions for resetting your password. Didn't get it? "
                        },
                        {
                            type: 8,
                            value: "Link",
                            children: [
                                {
                                    type: 0,
                                    value: "Resend Email"
                                }
                            ]
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        Link: function(chunks) {
                            return /*#__PURE__*/ _jsx(EmbeddedLink, {
                                onClick: onResend,
                                children: chunks
                            });
                        }
                    })
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "4iObSF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Still not seeing the email? "
                        },
                        {
                            type: 8,
                            value: "ContactFormLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Let Us Know"
                                }
                            ]
                        }
                    ],
                    values: {
                        ContactFormLinkFormatting: ContactFormLinkFormatting
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error
            }),
            /*#__PURE__*/ _jsx(GrowingSpacer, {})
        ]
    });
};
